import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import ListWorkspaces from './ListWorkspaces';
import ListWorkspacesActions from "./ListWorkspacesActions";
import ModalWorkspace from "./ModalWorkspace";

const FormWorkSpace = ({ history, location }) => {

    const [spaces, setSpaces] = useState([]);
    const [spaceModal,setSpaceModal] = useState(false);

    useEffect(() => {
    }, []);

    const getWorkspaces = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}espacio/listar`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Error');
            }
        }).then(data => {
            setSpaces(data);
        }).catch(err => {
            setSpaces([]);
            alert("Ha ocurrido un error en el sistema");
        });
    }

    useEffect(() => {
        getWorkspaces();
    }, [])

    const addSpace = () => 
    {
        setSpaceModal(true);
    }

    const Workspaces = () => {
        return (
            <ListWorkspaces
                reactTableData={spaces}
                ReactTableActions={ListWorkspacesActions}
                refresh={getWorkspaces}
            />
        );
    }

    return (
        <Container>
            <div className="text-center">
                <Button onClick={addSpace} className="btn btn-primary btn-sm text-white">
                    Agregar Espacio
                </Button>
            </div>

            <Row>
                <Col md={1}></Col>
                <Col md={10}><Workspaces /></Col>
                <Col md={1}></Col>
            </Row>

            <ModalWorkspace
            openModal={spaceModal}
            closeModal={() => setSpaceModal(false)}
            refresh={getWorkspaces}
            dataSpace={null}
            />

        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_workspaces',
})(FormWorkSpace);